export const orderDetails = '/newActivity/orderDetails';
export const orderEvents = '/newActivity/orderEvents';

export const orderEventsBody = {
	filters: [
		{
			code: 'trajet',
			value: 'Trajet',
			count: 12,
		},
		{
			code: 'activity',
			value: 'Activité',
			count: 8,
		},
		{
			code: 'appel_offer',
			value: "Appel d'offres",
			count: 2,
		},
		{
			code: 'documents',
			value: 'Documents',
			count: 30,
		},
		{
			code: 'incidents',
			value: 'Incidents',
			count: 25,
		},
		{
			code: 'message',
			value: 'Message',
			count: 20,
		},
	],
	ChargementID: 'eee',
};
